import React, { useState, useEffect, useRef } from "react";
import ClipboardButton from "./ClipboardButton";
import TrashIcon from "./img/trash.webp";
import ShareIcon from "./img/share.webp";
import KachelAbschluss from "./kachelabschluss";
import ConfirmButton from "./ConfirmButton";

import auswahlenIcon from "./img/auswahlen.png";
import { useConfig } from "./ConfigContext";

const isDevMode = import.meta.env.DEV;

export default function KachelRestMenu({
   setShowAll,
   projektstufe,
   kachelData,
   estateId,
   removeKachel,
   changeData,
   data,
   eskstatus,
   kachelAbschliessen,
   loading,
   user,
   editLayout,
   setEditLayout,
}) {
   const config = useConfig();
   return (
      <>
         <input
            type="text"
            placeholder={kachelData.heading}
            className="kachel-heading"
            onChange={(e) => changeData(e.target.name, e.target.value, "single")}
            name={"heading_" + kachelData.kachelId}
            value={
               data["heading_" + kachelData.kachelId] != undefined
                  ? data["heading_" + kachelData.kachelId]
                  : kachelData.heading
            }
         />
         <button
            className="share-button"
            disabled={!(config.company === "bender" || ["globaladmin"].includes(user.role))}
            style={editLayout ? { boxShadow: "0 0 18px 2px #0006", transform: "scale(1.1)" } : {}}
            title="Kacheleinstellungen und Layout bearbeiten"
            onClick={(e) => {
               e.preventDefault();
               setShowAll(!editLayout)
               setEditLayout((prev) => !prev);
            }}
         >
            <img src={auswahlenIcon} />
         </button>

         {!kachelData.unSkippable && (
            <KachelAbschluss
               eskstatus={eskstatus}
               kachelAbschliessen={kachelAbschliessen}
               kachelId={kachelData.kachelId}
            />
         )}
         <ClipboardButton
            content={
               "https://programme.baur-immobilien.de/datenblatt?estateid=" +
               estateId +
               "&stufe=" +
               projektstufe +
               "&kachel=" +
               kachelData.kachelId
            }
            icon={ShareIcon}
            tooltip={"Link in Zwischenablage kopieren, um in Teams usw. zu teilen"}
         />

         {!kachelData.notRemovable && (
            <ConfirmButton
               disabled={loading === "loading"}
               myFunction={() => {
                  removeKachel(projektstufe, kachelData.heading, kachelData);
               }}
               myText={"Kachel entfernen: Kann wieder hergestellt werden und Inhalt bleibt erhalten"}
               myName={""}
               myIcon={TrashIcon}
               myStyle={{}}
               myClassName={"share-button"}
            />
         )}

         {/*  <button
               className="share-button"
               style={{}}
               disabled={loading === "loading"}
               title="Kachel entfernen: Kann wieder hergestellt werden und Inhalt bleibt erhalten"
               onClick={(e) => {
                  e.preventDefault();
                  removeKachel(projektstufe, kachelData.heading, kachelData);
               }}
            >
               <img src={TrashIcon} />
            </button> */}
      </>
   );
}
